const currencyAPI = {
  fetchAPI: function () {
    const apiUrl =
      "https://api.freecurrencyapi.com/v1/latest?apikey=UhWeFxxmotI7rIeGbGCJgbMDw4AlF8vgaujaAlMP&base_currency=GBP";

    const currencySelect = document.getElementById("currency-picker");
    const productPriceElement = currencyAPI.getProductPriceElement();
    if (productPriceElement) {
      const productCurSymbol = document.getElementById("currency-symbol");
      let price = productPriceElement.dataset.gbpPrice;
      const priceShown = document.querySelector(
        ".price-container-currency-text .currency-text"
      );
      const priceShownMob = document.querySelector(
        ".price-container-currency-text--mobile .currency-text"
      );

      function togglePriceShown() {
        if (currencySelect.value === "GBP") {
          priceShown.parentNode.classList.add("d-none");
          if (priceShownMob != undefined) {
            priceShownMob.parentNode.classList.add("d-none");
          }
        } else {
          priceShown.parentNode.classList.remove("d-none");
          if (priceShownMob != undefined) {
            priceShownMob.parentNode.classList.remove("d-none");
          }
        }
      }

      if (currencySelect != undefined) {
        togglePriceShown();

        currencySelect.addEventListener("change", function () {
          price = productPriceElement.dataset.gbpPrice;

          const selectedCurrency = currencySelect.value;
          fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
              const exchangeRate = data.data[selectedCurrency];
              const originalPrice = parseFloat(price);
              var symbol = "£";
              if (selectedCurrency == "USD") {
                symbol = "$";
              }
              if (selectedCurrency == "EUR") {
                symbol = "€";
              }

              // Calculate the updated price based on the exchange rate
              const updatedPrice =
                parseFloat(originalPrice) * parseFloat(exchangeRate);

              // Update the displayed price with the new value
              const currentPriceElement = currencyAPI.getProductPriceElement();
              currentPriceElement.innerHTML = `
                                <div><span id="currency-symbol">${
                                  symbol ?? "£"
                                }</span><span class="variation-product-price">${updatedPrice.toFixed(
                2
              )}</span></div>
                                <span class="vat">ex. VAT</span>
                            `;

              // Update the "price shown" message.
              priceShown.textContent = selectedCurrency;

              togglePriceShown();
            });
        });
      }
    }
  },

  getProductPriceElement: function () {
    const productPriceElements = document.querySelectorAll(
      "#variation-product-price"
    );
    let finalElement = 0;

    productPriceElements.forEach((element) => {
      const price = parseFloat(element.dataset.gbpPrice);

      if (!isNaN(price)) {
        finalElement = element;
      }
    });

    return finalElement;
  },
};

export default currencyAPI;
